const playVideo = document.querySelector('.video__wrapper__play')

if (playVideo) {

    const player = videojs.getPlayer("video-js")

    const videoJS = document.querySelector('.video__js')
    const video = document.querySelector('.video__wrapper')
    const closeVideo = document.querySelector('.video__js__close')

    const videoWrapper = document.querySelector('.video')

    playVideo.addEventListener('click', function() {
        videoJS.classList.remove('dn')
        video.classList.add('dn')
        videoWrapper.classList.add('active')
        player.volume(0.3)
        player.play()
    })
    closeVideo.addEventListener('click', function() {
        video.classList.remove('dn')
        videoJS.classList.add('dn')
        videoWrapper.classList.remove('active')
        const src = player.currentSrc()
        player.reset()
        player.src(src);
    })
}